<template >
  <Modal v-bind="$attrs" @cancel="$emit('cancel')" @confirm="onConfirm">
    <el-form ref="form" @submit.native.prevent :model="budgetForm" inline :rules="rules">
      <el-form-item :prop="budgetType" label="日预算">
        <el-radio-group style="margin-left: 10px" class="radio-group" v-model="budgetForm.budget">
          <div>
            <el-radio :label="0">不限</el-radio>
          </div>
          <div>
            <el-radio :label="1">
              <el-input
                v-model.trim="budgetForm[budgetType]"
                @focus="onInputFocus"
                @keyup.native.enter="onConfirm"
                placeholder="请输入预算"
              ></el-input>
            </el-radio>
          </div>
        </el-radio-group>
      </el-form-item>
    </el-form>
  </Modal>
</template>
<script>
import Modal from './modal.vue'
import getBidFormRules from '@/views/create/gdt/model/budget/budget-rules.js'

export default {
  components: { Modal },
  props: {
    currentRow: Object
  },
  data() {
    return {
      budgetForm: {},
      rules: getBidFormRules.call(this)
    }
  },
  computed: {
    rawBidForm() {
      return this.currentRow?.bid
    },
    budgetType() {
      // 总预算ada才有
      return this.$attrs.title.includes('总预算') ? 'total_budget' : 'daily_budget'
    }
  },
  watch: {
    /**
     * @description: 打开弹窗时，使用当前列的出价参数，只有预算参数能更改，其他的参数作为rules的校验条件，需要使用到
     * @return {*}
     */
    '$attrs.visible'(v) {
      if (v) {
        this.budgetForm = this.rawBidForm
      }
    }
  },

  methods: {
    onInputFocus() {
      this.budgetForm.budget = 1
    },
    onConfirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$emit('confirm', this.budgetForm)
        }
      })
    }
  }
}
</script>
